
import * as React from 'react';
import { MdArrowDropDown, MdFolder } from 'react-icons/md';

import { Tooltip } from 'ui/common/tooltip/tooltip';
import { Link } from 'react-router';
import { MeatballMenu } from 'ui';
import styles from './select-option-link.scss';
import { insertOptionalWordbreaks } from 'app/infrastructure/platform';
import { SelectOptionValue } from 'app/area/code-selector/types';

export interface SelectOptionLinkProps {
  data: SelectOptionValue;
  onClick?: (itemId: number) => void;
  onExpand: (item: SelectOptionValue) => void;
  urlResolver: (value: number[]) => Object;
  dropdownItems?: React.ReactNode;
  labelItems?: React.ReactNode;
  defaultIcon?: React.ReactNode;
}

interface SelectOptionLinkState {
  dropdownOpen: boolean;
}

export class SelectOptionLink extends React.Component<SelectOptionLinkProps, SelectOptionLinkState> {

  public state:Readonly<SelectOptionLinkState> = {
    dropdownOpen: false
  };

  private onClick = (e: React.MouseEvent<any>) => {
    if (this.props.onClick) {
      e.preventDefault();
      this.props.onClick(this.props.data.value);
    }
  }

  private expandDropdown = () => {
    this.setState({dropdownOpen: true});
  }

  private closeDropdown = () => {
    this.setState({dropdownOpen: false});
  }

  private onExpand = (e: any) => {
    e.preventDefault();
    this.props.onExpand(this.props.data);
  }

  public render() {
    const { urlResolver, data, dropdownItems, labelItems, defaultIcon } = this.props;
    const { dropdownOpen } = this.state;

    const icon = !!data.icon ? <img className={`${styles.selectCodeBtnIcon}`} src={data.icon} /> : defaultIcon;
    const folder = <MdFolder className={`${styles.selectCodeBtnIcon} ${styles.defaultIcon}`} />;

    const isFolder = !!data.descendants;
    const folderClickHandler = isFolder ? this.onExpand : this.onClick;
    const url = urlResolver && urlResolver([data.value]);
    return (<li className={`col-6 col-md-4 col-lg-3 col-xl-2 ${styles.selectOption} ${dropdownOpen ? styles.expanded : ''} select-option`}>
      {dropdownItems && <div className={styles.meatballContainer}>
        <MeatballMenu className={isFolder ? styles.whiteDots : ''} onExpandMenu={this.expandDropdown} onCloseMenu={this.closeDropdown}>
          {dropdownItems}
        </MeatballMenu>
        </div>}
        {labelItems && <div className={styles.labelContainer}>{labelItems}</div>}
      <Link to={!isFolder ? url : '#'} onClick={folderClickHandler}>
        <Tooltip className={`${styles.selectCodeBtn} ${isFolder && styles.selectFolder}`} title={data.longDescription}>
          {isFolder ? folder : icon}
          <span className={`${styles.selectCodeBtnTitle}`}>
            {insertOptionalWordbreaks(data.description)}{isFolder && <MdArrowDropDown />}
          </span>
        </Tooltip>
      </Link>
    </li>);
  }
}
